import { connect } from 'react-redux';
import ScribeSetCurseFilter from './ScribeSetCurseFilter';
import { setCurseFilter } from '../../actions/conversation/index';

const mapStateToProps = ({ scribeConversation: { curseFilter } }) => ({
  curseFilter,
});

const mapDispatchToProps = dispatch => ({
  setCurseFilter: value => dispatch(setCurseFilter(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ScribeSetCurseFilter);
